const siteConfig = {
  name: 'UZD SRM',
  owner: 'UZD Parts',
  description: 'Sales Relationship Management system for UZD Parts',
  version: '4.13.1',
  // Increment build_no with every deployment.
  // Socket events with a build_no <= this value are silently ignored.
  build_no: 11042034,
};

export default siteConfig;
